import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme: any) => ({
  fileShow: {
    backgroundColor: theme.palette.brand.greyLight,
    borderRadius: theme.spacing(1),
    width: '100%',
    fontWeight: 'bold',
    fontSize: '12px',
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    display: 'flex',
  },
  loadingCircle: {
    marginRight: theme.spacing(2),
  },
  deleteButton: {
    width: '10%%',
    color: 'red',
    fontSize: '12px',
    padding: 0,
  },
  fileText: {
    width: '90%',
    textAlign: 'initial',
    alignSelf: 'center',
    marginLeft: theme.spacing(1),
  },
  uploadBox: {
    maxHeight: theme.spacing(13),
    marginTop: theme.spacing(2),
    overflowY: 'scroll',
  },
}));

export default function UploadedFilesToShow({
  files,
  loading,
  deleteFile,
}: any) {
  const classes = useStyles({ loading });

  return (
    <div className={classes.uploadBox}>
      {files.map((file, id) => (
        <div
          key={id}
          className={classes.fileShow}
          style={{ marginTop: id === 0 ? 0 : 8 }}
        >
          <span className={classes.fileText}>
            {file.loading && (
              <CircularProgress
                color="primary"
                size={15}
                className={classes.loadingCircle}
              />
            )}
            {file.name}
          </span>
          <Button
            onClick={async () => await deleteFile(file)}
            disabled={file.loading || loading}
            className={classes.deleteButton}
          >
            Remove
          </Button>
        </div>
      ))}
    </div>
  );
}
